import pick from 'lodash/pick'

import { serializeSearchState } from 'actions/utils/search'

export const formatUrlWithFilters = (filters: any, url: string) => {
  const relevantFilters = pick(filters, [
    'startDate',
    'endDate',
    'children',
    'adults',
    'pets',
  ])
  // @ts-ignore -- serializeSearchState not typed yet
  const searchQuery = serializeSearchState(relevantFilters)

  if (searchQuery && searchQuery.length > 0) {
    return `${url}?${searchQuery}`
  }
  return url
}
